import React from 'react';
import { observer } from 'mobx-react-lite';

import { TOrderMetricEntity, useMst } from '@trader/store';
// import { getRequiredOpenCostQuantity } from '@trader/utils';
import { useI18next } from '@trader/services';
// import { getTradingModelBE } from '@trader/contexts';
import { TPlaceOrderType } from '@trader/types';

import * as Styled from './styled';

interface IPlaceOrderButton {
  isDisabled: boolean;
  orderType: TPlaceOrderType;
  buttonTitle?: string;
  onClick?: () => void;
}

export const PlaceOrderButton: React.FC<IPlaceOrderButton> = observer(
  ({
    isDisabled,
    // orderType,
    buttonTitle = 'COMMON.LABELS.PLACE_ORDER',
    // onClick,
  }) => {
    const store = useMst();
    const { translate } = useI18next();

    // const [isSubmitInProgress, setIsSubmitInProgress] = useState(false);
    // const [isOrderProcessing, setIsOrderProcessing] = useState(false);

    const trading = store.trading;
    // const instrument = trading.instrument as TInstrumentEntity;

    const orderId = store.ui.modal?.options.get('orderId');
    // const isInvestmentAccProduct = store.user.isInvestmentAccProduct();

    const metric =
      store.entities.ordersMetrics.get<TOrderMetricEntity>(orderId);

    const isInProgress =
      store.trading.prePlaceOrderAsync.inProgress ||
      (metric && metric.editOrderAsync.inProgress);

    // const handlePlaceOrder = async () => {
    //   const orderModelBE = getTradingModelBE(
    //     orderType,
    //     instrument,
    //     realTimePrice
    //   );
    //   const quantity = getRequiredOpenCostQuantity(
    //     orderModelBE.quantity,
    //     instrument.market.minAmountValue
    //   );
    //
    //   const onSuccess = () => {
    //     if (onClick) {
    //       onClick();
    //     } else {
    //       store.pages.trading.placeOrderAsync.run(orderModelBE)?.then(() => {
    //         setIsOrderProcessing(true);
    //       });
    //
    //       // The values will be used in socket handlers
    //       // to show the order response modal correctly.
    //       store.ui.modal.update({
    //         isPositionPlaced: orderType === 'Market' && !isInvestmentAccProduct,
    //         isOrderPlaced:
    //           orderType === 'EntryLimit' ||
    //           orderType === 'EntryStop' ||
    //           isInvestmentAccProduct,
    //       });
    //     }
    //   };
    //
    //   const onError = errorType => {
    //     if (errorType !== EErrorTypes.INSUFFICIENT_FUNDS) {
    //       onSuccess();
    //     }
    //   };
    //
    //   setIsSubmitInProgress(true);
    //
    //   // Check the insufficient funds error.
    //   // Only after the successfully check we can place the order.
    //   await getRequiredOpenCost(
    //     orderModelBE.symbol,
    //     orderModelBE.side,
    //     quantity,
    //     orderModelBE.price ?? 0,
    //     onSuccess,
    //     onError,
    //     true
    //   );
    //
    //   setIsSubmitInProgress(false);
    // };

    return (
      <Styled.Root>
        <Styled.PlaceOrder
          type='submit'
          loading={isInProgress}
          disabled={isInProgress || isDisabled || trading.isOrderInPending}
        >
          <Styled.Title>
            {trading.isOrderInPending
              ? translate('COMMON.LABELS.PROCESSING')
              : translate(buttonTitle)}
          </Styled.Title>
        </Styled.PlaceOrder>
      </Styled.Root>
    );
  }
);
